import React, { useState, useEffect, useRef } from 'react';
import { Box, Typography, CircularProgress, Button } from '@mui/material';
import './SeleccionarTratamiento.css';

const SeleccionarTratamiento = ({
  onSeleccion,
  onTratamientoSeleccionado,
  seleccionadoInicial = null
}) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [tratamientos, setTratamientos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categoriaActiva, setCategoriaActiva] = useState('lista');
  const containerRef = useRef(null);

  useEffect(() => {
    const fetchTratamientos = async () => {
      try {
        const response = await fetch(`${apiUrl}/api/tratamientosactivos`);
        const data = await response.json();

        // Clasificación por marca
        const clasificarTratamiento = (t) => {
          const marca = t.marca?.toLowerCase() || '';
          if (marca === 'lista') return 'lista';
          if (marca.includes('sweet')) return 'sweetprofesional';
          if (marca === 'especial') return 'mayores65';
          if (marca === 'icon') return 'icon';
          return 'otros';
        };

        const tratamientosConCategoria = data.map(t => ({
          ...t,
          categoriaAsignada: clasificarTratamiento(t)
        }));

        const tratamientosOrdenados = tratamientosConCategoria.sort((a, b) =>
          a.nombre_tratamiento.localeCompare(b.nombre_tratamiento)
        );

        setTratamientos(tratamientosOrdenados);
      } catch (error) {
        console.error("Error cargando tratamientos:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTratamientos();
  }, []);

  const categorias = [
    { id: 'lista', nombre: 'Lista de Precios' },
    { id: 'sweetprofesional', nombre: 'Sweet Profesional' },
    { id: 'mayores65', nombre: 'Mayores 65' },
    { id: 'icon', nombre: 'ICON' }
  ];

  const getTratamientosPorCategoria = (categoriaId) => {
    return tratamientos.filter(t => t.categoriaAsignada === categoriaId);
  };

  const handleClickTratamiento = (tratamiento) => {
    onSeleccion(tratamiento);
    if (typeof onTratamientoSeleccionado === 'function') {
      onTratamientoSeleccionado();
    }
  };

  return (
    <Box className="seleccionar-tratamiento-container">
      <Box className="folder-tabs">
        {categorias.map((categoria) => (
          <Button
            key={categoria.id}
            className={`
              folder-tab
              ${categoriaActiva === categoria.id ? 'active' : ''}
              ${categoria.id === 'sweetprofesional' ? 'sweet-tab' : ''}
              ${categoria.id === 'mayores65' ? 'especial-tab' : ''}
              ${categoria.id === 'icon' ? 'icon-tab' : ''}
            `}
            onClick={() => setCategoriaActiva(categoria.id)}
          >
            {categoria.nombre}
          </Button>
        ))}
      </Box>

      {loading ? (
        <Box className="loading-container">
          <CircularProgress />
        </Box>
      ) : (
        <Box className="tratamientos-grid-container" ref={containerRef}>
          <Box className="tratamientos-grid">
            {getTratamientosPorCategoria(categoriaActiva).map((tratamiento) => {
              const isSelected = seleccionadoInicial?.id_tratamiento === tratamiento.id_tratamiento;
              return (
                <Box
                  key={tratamiento.id_tratamiento}
                  className={`tratamiento-card ${isSelected ? 'selected' : ''}`}
                  onClick={() => handleClickTratamiento(tratamiento)}
                >
                  <Typography className="tratamiento-nombre">
                    {tratamiento.nombre_tratamiento}
                  </Typography>
                  <Typography className="tratamiento-precio">
                    {tratamiento.precio_tratamiento}€
                  </Typography>
                </Box>
              );
            })}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default SeleccionarTratamiento;
